import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { useServiceDrawer } from "./useServiceDrawer";
import { ReportProblem } from "@mui/icons-material";
import { cancelReturns, cancelShipment } from "./returnApi";
import toast from "react-hot-toast";

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    p: 4,
    borderRadius: "6px",
};

const ReturnsCancelModal = () => {
    const { id, isCancelReturnsOpen, onCloseCanel, setSyncReturns } =
        useServiceDrawer();

    const cancelReturnsHandler = () => {
        cancelReturns([id as string])
            .then((data) => {
                toast.success("Return cancelled successfully!");
                setSyncReturns();
                onCloseCanel();
            })
            .catch((err) => {
                toast.error("Unable to cancel service");
            });
    };

    const cancelServiceHandler = () => {
        cancelShipment([id as string])
            .then((data) => {
                toast.success("Service cancelled successfully!");
                setSyncReturns();
                onCloseCanel();
            })
            .catch((err) => {
                console.log(err);
                toast.error("Unable to cancel Return");
            });
    };

    return (
        <Modal open={isCancelReturnsOpen} onClose={onCloseCanel}>
            <Box sx={style}>
                <Stack
                    justifyContent={"space-between"}
                    direction={"column"}
                    sx={{
                        minHeight: "200px",
                    }}
                >
                    <Stack justifyContent={"center"} alignItems={"center"}>
                        <ReportProblem
                            sx={{
                                fontSize: "80px",
                                color: "red",
                            }}
                        />
                        <Typography textAlign={"center"}>
                            Are you sure you want to cancel this returns?
                        </Typography>
                    </Stack>
                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        gap={"8px"}
                    >
                        <Button
                            onClick={onCloseCanel}
                            size="small"
                            sx={{
                                textTransform: "none",
                            }}
                            variant="outlined"
                        >
                            Don't Cancel
                        </Button>
                        <Button
                            size="small"
                            sx={{
                                textTransform: "none",
                                bgcolor: "red",
                                ":hover": {
                                    bgcolor: "#ff0000cc",
                                },
                            }}
                            variant="contained"
                            onClick={cancelServiceHandler}
                        >
                            Cancel Service
                        </Button>
                        <Button
                            size="small"
                            sx={{
                                textTransform: "none",
                                bgcolor: "red",
                                ":hover": {
                                    bgcolor: "#ff0000cc",
                                },
                            }}
                            variant="contained"
                            onClick={cancelReturnsHandler}
                        >
                            Cancel Return
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
};

export default ReturnsCancelModal;
